/**
 * Courier payment states, transcribed verbatim from the old panel's
 * `assets/data/product_paid_status.ts`. The id comes off the wire as
 * `courier_payment_status`; the name keys into the `payment_status.*` i18n
 * namespace (the old app kept these at the i18n root).
 */
export const LEGACY_COURIER_PAYMENT_STATUSES = [
  { id: 0, statusName: 'not_paid' },
  { id: 1, statusName: 'pending_cash' },
  { id: 2, statusName: 'paid_cash' },
  { id: 3, statusName: 'pending_balance' },
  { id: 4, statusName: 'processing_balance' },
  { id: 5, statusName: 'paid_balance' },
  { id: 6, statusName: 'debt' },
  { id: 7, statusName: 'debt_review' },
  { id: 8, statusName: 'courier_have_to_select' },
] as const;

/**
 * The "Статус товара" label, reproducing the old four-way fallback exactly
 * (`OrderOtherInfo` and the list's `product_paid` cell shared it):
 * no goods → "Нету продуктов"; `product_paid` → "Оплачен"; else the courier
 * payment status's own vocabulary when the id is known; else "Не оплачен".
 *
 * Returns an i18n KEY into the `legacy` namespace.
 */
export function legacyProductPaidLabelKey({
  totalProductPrice,
  productPaid,
  courierPaymentStatus,
}: {
  totalProductPrice: number;
  productPaid: boolean;
  courierPaymentStatus: number | null;
}): string {
  if (!totalProductPrice) return 'single.not_products';
  if (productPaid) return 'single.paid';
  const status = LEGACY_COURIER_PAYMENT_STATUSES.find(
    (s) => s.id === courierPaymentStatus,
  );
  if (status) return `payment_status.${status.statusName}`;
  return 'single.notpaid';
}
